module.exports = __webpack_public_path__ + "img/图片8.303e17bf.png";